import { render, staticRenderFns } from "./SemenReceipt.vue?vue&type=template&id=7922a352&scoped=true&"
import script from "./SemenReceipt.vue?vue&type=script&lang=js&"
export * from "./SemenReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7922a352",
  null
  
)

export default component.exports